import React, { useState } from 'react';
import MaytapiPhones from './MaytapiPhones';
import DispatchQueue from './DispatchQueue';
import KpiDeControl from './KpiDeControl';
import ReglasDelPolicia from './dispatch/ReglasDelPolicia';

/**
 * El WhatsApp de recobro, partido en dos.
 *
 * 🔴 La división no es cosmética: son **dos trabajos distintos que se hacen en
 * momentos distintos**. Configurar se hace una vez y se toca poco; auditar se
 * hace todos los días. Mezclados, la pantalla era una lista de seis bloques sin
 * un orden que dijera para qué servía cada uno, y la queja de Edgar el
 * 15/09/2026 fue literalmente ésa: «hay muchas estadísticas que realmente no sé
 * si tienen sentido o para qué sirven».
 *
 * Qué se fue ese día, y por qué:
 *
 * - **Previsión de envíos** — era lo único de la página que no medía: proyectaba
 *   con «media de la última semana + 1 envío por respuesta», y el «Overflow» y
 *   el «Factor respuestas» eran supuestos. La pregunta que contestaba —¿me voy a
 *   atascar?— la contesta mejor la cola, que dice qué está atascado AHORA y con
 *   qué motivo.
 * - **Estadísticas de hoy** — la tabla nueva, pero de un solo día y sin
 *   respuestas. Cabe como su primera fila.
 * - **El modal por línea** — diez días de lo mismo, escondido tras un clic.
 *
 * Ninguna de las tres enseñaba una sola respuesta del deudor, ni cuántas
 * conversaciones abría cada línea. Las dos cosas están ahora en KPI de control.
 */

const PESTANAS = [
  {
    id: 'kpi',
    nombre: 'KPI de control',
    detalle: 'Qué salió, qué contestaron y qué está parado',
  },
  {
    id: 'config',
    nombre: 'Configuración',
    detalle: 'Las líneas y las reglas del despachador',
  },
];

const WhatsAppRecobro = () => {
  // Arranca en KPI: es lo que se viene a mirar a diario. La configuración se
  // toca mucho menos, y cuando se toca se viene a por ella a propósito.
  const [pestana, setPestana] = useState('kpi');

  return (
    <>
      <div className='bg-white rounded-lg border border-slate-200'>
        <div className='flex'>
          {PESTANAS.map((p) => (
            <button
              key={p.id}
              type='button'
              onClick={() => setPestana(p.id)}
              className={`flex-1 text-left px-6 py-4 border-b-2 ${
                pestana === p.id
                  ? 'border-indigo-600 bg-slate-50'
                  : 'border-transparent hover:bg-slate-50'
              }`}
            >
              <span
                className={`block text-sm font-medium ${
                  pestana === p.id ? 'text-indigo-700' : 'text-slate-700'
                }`}
              >
                {p.nombre}
              </span>
              <span className='block text-xs text-slate-500 mt-0.5'>{p.detalle}</span>
            </button>
          ))}
        </div>
      </div>

      {pestana === 'kpi' && (
        <>
          <KpiDeControl />
          {/* La cola va con los KPI y no con la configuración: cuando algo no
              sale, lo primero es saber qué espera y por qué. */}
          <DispatchQueue />
        </>
      )}

      {pestana === 'config' && (
        <>
          <MaytapiPhones />
          <ReglasDelPolicia />
        </>
      )}
    </>
  );
};

export default WhatsAppRecobro;
